/* global fetchPositionActivitiesGanttChartDataUrl fetchPositionActivitiesAllocationsUrl fetchPositionActivitiesCostsUrl updatePositionActivitiesAllocationsUrl */
/* global position */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import moment from 'moment';

import GanttChart from './components/GanttChart';
import { AllocationFormProvider } from './context/AllocationFormContext';
import { PositionActivitiesProvider, useProjectActivitiesContext } from './context/PositionActivitiesContext';

import Button from 'CommonComponents/Button';
import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import TableSearchInput from 'CommonComponents/TableSearchInput';

const PositionActivitiesApp = () => {
    const { filters, changeFilters, toggleAllRows, isResourceAllocationMode, allocations, setIsResourceAllocationMode, ganttChart } =
        useProjectActivitiesContext();

    return (
        <AllocationFormProvider initialAllocations={allocations.data}>
            {({ handleSubmit, handleReset, isSubmitting, isValid, errors }) => (
                <div className="table__card tw-flex tw-flex-col tw-h-full tw-space-y-8">
                    <h3 className="table__header">{$t('Position Activities')}</h3>

                    <div className="tw-flex tw-flex-col tw-min-h-0 tw-h-full tw-space-y-4">
                        <div className="tw-flex tw-gap-x-4 tw-justify-between tw-items-end">
                            <div className="tw-py-1 tw-flex tw-gap-x-2 tw-items-baseline">
                                <div className="tw-text-xs tw-font-medium tw-text-charcoal-50">{$t('Row view')}</div>
                                <div className="tw-flex tw-gap-x-1.5">
                                    <button className="tw-text-xs tw-font-medium tw-text-charcoal tw-underline" onClick={() => toggleAllRows(true)}>
                                        {$t('Expand all')}
                                    </button>
                                    <button className="tw-text-xs tw-font-medium tw-text-charcoal tw-underline" onClick={() => toggleAllRows(false)}>
                                        {$t('Collapse all')}
                                    </button>
                                </div>
                            </div>
                            <div className="tw-flex tw-items-center tw-gap-x-3">
                                <div className="tw-flex tw-items-center tw-gap-x-1.5">
                                    {isResourceAllocationMode ? (
                                        <>
                                            <Button
                                                variant="primary"
                                                loading={isSubmitting}
                                                disabled={isSubmitting || !isValid}
                                                onClick={() => {
                                                    handleSubmit();
                                                }}
                                            >
                                                {$t('Save')}
                                            </Button>
                                            <Button
                                                variant="danger"
                                                disabled={isSubmitting}
                                                onClick={() => {
                                                    handleReset();
                                                    setIsResourceAllocationMode(false);
                                                }}
                                            >
                                                {$t('Cancel')}
                                            </Button>
                                        </>
                                    ) : (
                                        <Button variant="primary" onClick={() => setIsResourceAllocationMode(true)}>
                                            {$t('Edit Resource Allocation')}
                                        </Button>
                                    )}
                                </div>
                                <TableSearchInput searchValue={filters.search || ''} handleEnterPress={(e, value) => changeFilters({ search: value })} />
                            </div>
                        </div>

                        <div className="tw-relative tw-min-h-0 tw-h-full tw-w-full">
                            <div className="tw-absolute tw-w-full tw-max-w-md tw-top-1 tw-inset-x-0 tw-mx-auto tw-z-10">
                                <div className="tw-flex tw-flex-col tw-justify-center tw-gap-y-2">
                                    {isResourceAllocationMode &&
                                        errors &&
                                        Object.keys(errors).length > 0 &&
                                        Object.entries(errors).map(([monthKey, monthErrorMessage]) => (
                                            <div
                                                key={monthKey}
                                                className="tw-bg-red-100 tw-text-red-800 tw-text-xs tw-px-3 tw-py-2 tw-border-2 tw-border-red-200 tw-rounded"
                                            >
                                                <div>
                                                    {monthErrorMessage ||
                                                        $t('There are allocation errors in {{month}}', {
                                                            month: moment(monthKey, 'MM-YYYY').format('MMMM YYYY'),
                                                        })}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                            {ganttChart.loading ? (
                                <div className="tw-min-h-0 tw-h-full tw-w-full tw-mb-10 tw-flex tw-items-center tw-justify-center">
                                    <LoadingSpinner />
                                </div>
                            ) : (
                                <GanttChart />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </AllocationFormProvider>
    );
};

if (document.getElementById('project-activities-app')) {
    var rootEl = document.getElementById('project-activities-app');
    ReactDOM.render(
        <App>
            <PositionActivitiesProvider
                fetchPositionActivitiesGanttChartDataUrl={fetchPositionActivitiesGanttChartDataUrl}
                fetchPositionActivitiesAllocationsUrl={fetchPositionActivitiesAllocationsUrl}
                fetchPositionActivitiesCostsUrl={fetchPositionActivitiesCostsUrl}
                updatePositionActivitiesAllocationsUrl={updatePositionActivitiesAllocationsUrl}
                position={position}
                expandAllRowsInitially
            >
                <PositionActivitiesApp />
            </PositionActivitiesProvider>
        </App>,
        rootEl,
    );
}

export default PositionActivitiesApp;
